import { Button, Container, Grid, Tabs, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import '../App.css'
import SidebarItem from './SidebarItem'
import * as htmlToImage from "html-to-image";
import * as download from "downloadjs";
import Slider from './Slider';
import { Celebration, Opacity } from '@mui/icons-material';
import PhoneIcon from '@mui/icons-material/Phone';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import ContrastIcon from '@mui/icons-material/Contrast';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import FilterVintageIcon from '@mui/icons-material/FilterVintage';
import OpacityIcon from '@mui/icons-material/Opacity';
import SatelliteIcon from '@mui/icons-material/Satellite';
import ImageIcon from '@mui/icons-material/Image';

const ImageEditor = () => {

    const [origImage, setOrigImage] = useState("")
    const [origImageFile, setOrigImageFile] = useState("")
    const [fileName, setFileName] = useState("")
    const placeholderImageUrl="https://www.pulsecarshalton.co.uk/wp-content/uploads/2016/08/jk-placeholder-image.jpg"
    const marks = [
        {
          value: 0,
          label: '0%',
        },
        {
          value: 20,
          label: '20%',
        },
        {
          value: 50,
          label: '50%',
        },
        {
          value: 100,
          label: '100%',
        },
      ];
      function valuetext(value) {
        return `${value}%`;
      }

      const DEFAULT_OPTIONS = [
        {
          name: 'Brightness',
          icon: <WbSunnyIcon/>,
          property: 'brightness',
          value: 100,
          range: {
            min: 0,
            max: 200
          },
          unit: '%'
        },
        {
          name: 'Contrast',
          property: 'contrast',
          icon: <ContrastIcon/>,
          value: 100,
          range: {
            min: 0,
            max: 200
          },
          unit: '%'
        },
        {
          name: 'Saturation',
          property: 'saturate',
          icon: <InvertColorsIcon/>,
          value: 100,
          range: {
            min: 0,
            max: 200
          },
          unit: '%'
        },
        {
          name: 'Grayscale',
          property: 'grayscale',
          icon: <FilterVintageIcon/>,
          value: 0,
          range: {
            min: 0,
            max: 100
          },
          unit: '%'
        },
        {
          name: 'Sepia',
          property: 'sepia',
          icon: <ImageIcon/>,
          value: 0,
          range: {
            min: 0,
            max: 100
          },
          unit: '%'
        },
        {
          name: 'Hue Rotate',
          property: 'hue-rotate',
          icon: <OpacityIcon/>,
          value: 0,
          range: {
            min: 0,
            max: 360
          },
          unit: 'deg'
        },
        {
          name: 'Blur',
          property: 'blur',
          icon: <SatelliteIcon/>,
          value: 0,
          range: {
            min: 0,
            max: 20
          },
          unit: 'px'
        }
      ]

    const [selectedOptionIndex, setSelectedOptionIndex] = useState(0)
    const [options, setOptions] = useState(DEFAULT_OPTIONS)
    const selectedOption = options[selectedOptionIndex]

    function handleSliderChange({ target }) {
        setOptions(prevOptions => {
          return prevOptions.map((option, index) => {
            if (index !== selectedOptionIndex) return option
            return { ...option, value: target.value }
          })
        })
      }
    
    function getImageStyle() {
        const filters = options.map(option => {
          return `${option.property}(${option.value}${option.unit})`
        })
    
        return { filter: filters.join(' ') }
    }

    const handle = (e) => {
        const imageFile = e.target.files[0];
        setOrigImage(imageFile);
        setOrigImageFile(URL.createObjectURL(imageFile));
        setFileName(imageFile.name)
      }

    const downloadResume = () => {
        htmlToImage
          .toPng(document.getElementById("image"))
          .then(function (dataUrl) {
            download(dataUrl, `${fileName}`);
          });
      };

      const theme = useTheme();
      const isSm = useMediaQuery(theme.breakpoints.down("sm"));
      const isXs = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <>
         <Container sx={{textAlign:'center', my:5, display:'flex', flexDirection:'column', alignItems:'center'}}>
            <Button variant="contained" component="label" sx={{width:'200px'}}>
                Upload Image
                <input type="file" hidden accept="image/*" onChange={(e) => handle(e)} />
            </Button>
        </Container>
        <Grid container space={2}>
            <Grid item xs={12} sm={12} md={2} lg={2}>
                <Tabs
                    allowScrollButtonsMobile
                    orientation={(isXs||isSm) ? "horizontal" : "vertical" }
                    variant={(isXs||isSm) ? "scrollable" : "" }
                    sx={{ borderRight: 1, borderColor: 'divider' }}
                >  
                    {options.map((option, index) => {
                    return (
                        <SidebarItem
                        key={index}
                        icon={option.icon}
                        name={option.name}
                        active={index === selectedOptionIndex}
                        handleClick={() => setSelectedOptionIndex(index)}
                        />
                    )
                    })}
                </Tabs>
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={10} sx={{textAlign:'center', border:'1px solid #eee', height:'500px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                {origImageFile ? <img style={getImageStyle()} id="image" className="image" alt="uploaded pic" src={origImageFile}/> :  <img alt="placeholder" style={{width:'300px'}} src={placeholderImageUrl}/>}
            </Grid>
        </Grid>
        <Container>
        {origImageFile &&
            <Grid container sx={{my: 5}}>
               <Grid item xs={12} sx={{textAlign:'center'}}>
                   <Slider
                       min={selectedOption.range.min}
                       max={selectedOption.range.max}
                       value={selectedOption.value}
                       handleChange={handleSliderChange}
                   />
               </Grid>
               <Grid item xs={12} sx={{textAlign:'center', mt:3}}>
                   <Button variant="contained" onClick={downloadResume}>Download</Button>
               </Grid>
           </Grid>
        }
 

        </Container>
        
    </>

  )
}

export default ImageEditor